import { render, staticRenderFns } from "./FpTreeHeader.vue?vue&type=template&id=16a086f2&lang=pug&"
import script from "./FpTreeHeader.vue?vue&type=script&lang=js&"
export * from "./FpTreeHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports